/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SelectEditionRouteImport } from './routes/select-edition.route'
import { Route as DebugaccessRouteImport } from './routes/debugaccess.route'
import { Route as ContentNotFoundRouteImport } from './routes/content-not-found.route'
import { Route as CertificateV2RouteImport } from './routes/certificate-v2.route'
import { Route as BrowseRouteImport } from './routes/browse.route'
import { Route as AuthenticateRouteImport } from './routes/authenticate.route'
import { Route as AccountActionRouteImport } from './routes/account-action.route'
import { Route as AccessDeniedRouteImport } from './routes/access-denied.route'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite.route'
import { Route as R404RouteImport } from './routes/404.route'
import { Route as IndexRouteImport } from './routes/index.route'
import { Route as LearnIndexRouteImport } from './routes/learn/index.route'
import { Route as CreateIndexRouteImport } from './routes/create/index.route'
import { Route as CreateNewIndexRouteImport } from './routes/create-new/index.route'
import { Route as SkillSkillIdRouteImport } from './routes/skill/$skillId.route'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications.route'
import { Route as SettingsGeneralRouteImport } from './routes/settings/general.route'
import { Route as SettingsBrandingRouteImport } from './routes/settings/branding.route'
import { Route as ScormDispatchSplatRouteImport } from './routes/scorm-dispatch/$.route'
import { Route as RecoveryUsersRouteImport } from './routes/recovery/users.route'
import { Route as RecoveryLivesessionsRouteImport } from './routes/recovery/livesessions.route'
import { Route as RecoveryCoursesRouteImport } from './routes/recovery/courses.route'
import { Route as RSplatRouteImport } from './routes/r/$.route'
import { Route as ManageReportsRouteImport } from './routes/manage/reports.route'
import { Route as ManageOverviewRouteImport } from './routes/manage/overview.route'
import { Route as ManageContentRouteImport } from './routes/manage/content.route'
import { Route as GroupInviteTokenRouteImport } from './routes/group-invite/$token.route'
import { Route as DebugErrorSyncRouteImport } from './routes/debug/error-sync.route'
import { Route as DebugErrorAsyncRouteImport } from './routes/debug/error-async.route'
import { Route as DebugCollaborationRouteImport } from './routes/debug/collaboration.route'
import { Route as AdminErrorRouteImport } from './routes/admin/error.route'
import { Route as TTeamspaceIdIndexRouteImport } from './routes/t/$teamspaceId/index.route'
import { Route as SettingsApiIndexRouteImport } from './routes/settings/api/index.route'
import { Route as SFlexibleContentIdIndexRouteImport } from './routes/s/$flexibleContentId/index.route'
import { Route as RoomLiveRoomIdIndexRouteImport } from './routes/room/$liveRoomId/index.route'
import { Route as ProgramProgramIdIndexRouteImport } from './routes/program/$programId/index.route'
import { Route as PathPathIdIndexRouteImport } from './routes/path/$pathId/index.route'
import { Route as ManageUsersIndexRouteImport } from './routes/manage/users/index.route'
import { Route as ManageUserGroupsIndexRouteImport } from './routes/manage/user-groups/index.route'
import { Route as ManageTagsIndexRouteImport } from './routes/manage/tags/index.route'
import { Route as ManageSkillsIndexRouteImport } from './routes/manage/skills/index.route'
import { Route as ManageProgramsIndexRouteImport } from './routes/manage/programs/index.route'
import { Route as ManageInsightsIndexRouteImport } from './routes/manage/insights/index.route'
import { Route as ManageInPersonEventsIndexRouteImport } from './routes/manage/in-person-events/index.route'
import { Route as ManageExercisesIndexRouteImport } from './routes/manage/exercises/index.route'
import { Route as ManageCertificatesIndexRouteImport } from './routes/manage/certificates/index.route'
import { Route as LLiveSessionIdIndexRouteImport } from './routes/l/$liveSessionId/index.route'
import { Route as EventEventGroupIdIndexRouteImport } from './routes/event/$eventGroupId/index.route'
import { Route as CourseCourseIdIndexRouteImport } from './routes/course/$courseId/index.route'
import { Route as AdminPathsPlaygroundIndexRouteImport } from './routes/admin/paths-playground/index.route'
import { Route as TTeamspaceIdFolderIdRouteImport } from './routes/t/$teamspaceId/$folderId.route'
import { Route as SettingsApiApiClientIdRouteImport } from './routes/settings/api/$apiClientId.route'
import { Route as SFlexibleContentIdFileIdRouteImport } from './routes/s/$flexibleContentId/$fileId.route'
import { Route as ManageXApiXApiServerIdRouteImport } from './routes/manage/x-api/$xApiServerId.route'
import { Route as ManageUsersUserIdRouteImport } from './routes/manage/users/$userId.route'
import { Route as ManageUserGroupsGroupIdRouteImport } from './routes/manage/user-groups/$groupId.route'
import { Route as ManageTagsTagIdRouteImport } from './routes/manage/tags/$tagId.route'
import { Route as ManageProgramsProgramIdRouteImport } from './routes/manage/programs/$programId.route'
import { Route as ManagePathsPathIdRouteImport } from './routes/manage/paths/$pathId.route'
import { Route as ManageExercisesExerciseIdRouteImport } from './routes/manage/exercises/$exerciseId.route'
import { Route as ManageEventsLiveSessionIdRouteImport } from './routes/manage/events/$liveSessionId.route'
import { Route as ManageCoursesCourseIdRouteImport } from './routes/manage/courses/$courseId.route'
import { Route as ManageCourseGroupCourseGroupIdRouteImport } from './routes/manage/course-group/$courseGroupId.route'
import { Route as ManageCertificatesCertificateIdRouteImport } from './routes/manage/certificates/$certificateId.route'
import { Route as HistorySSplatRouteImport } from './routes/history/s/$.route'
import { Route as HistoryLSplatRouteImport } from './routes/history/l/$.route'
import { Route as CreateSNewRouteImport } from './routes/create/s/new.route'
import { Route as CreateSSplatRouteImport } from './routes/create/s/$.route'
import { Route as CreateLNewRouteImport } from './routes/create/l/new.route'
import { Route as CreateLSplatRouteImport } from './routes/create/l/$.route'
import { Route as CourseCourseIdScormRouteImport } from './routes/course/$courseId/scorm.route'
import { Route as CourseCourseIdNextRouteImport } from './routes/course/$courseId/next.route'
import { Route as CourseCourseIdSplatRouteImport } from './routes/course/$courseId/$.route'
import { Route as ManageInsightsDashboardsIndexRouteImport } from './routes/manage/insights/dashboards/index.route'
import { Route as ManageInPersonEventsEventGroupIdIndexRouteImport } from './routes/manage/in-person-events/$eventGroupId/index.route'
import { Route as CheckInEventGroupIdEventIdIndexRouteImport } from './routes/check-in/$eventGroupId/$eventId/index.route'
import { Route as ManageUserUserIdExportTranscriptRouteImport } from './routes/manage/user/$userId/export-transcript.route'
import { Route as ManageInPersonEventsEventGroupIdCalendarEventIdRouteImport } from './routes/manage/in-person-events/$eventGroupId/$calendarEventId.route'
import { Route as CreateExportSSelfPacedContentIdRouteImport } from './routes/create/export/s/$selfPacedContentId.route'
import { Route as CreateExportLLiveContentIdRouteImport } from './routes/create/export/l/$liveContentId.route'
import { Route as CheckInEventGroupIdEventIdQrRouteImport } from './routes/check-in/$eventGroupId/$eventId/qr.route'
import { Route as ProgramProgramIdSFlexibleContentIdIndexRouteImport } from './routes/program/$programId/s/$flexibleContentId/index.route'
import { Route as ProgramProgramIdPathPathIdIndexRouteImport } from './routes/program/$programId/path/$pathId/index.route'
import { Route as ProgramProgramIdEventEventGroupIdIndexRouteImport } from './routes/program/$programId/event/$eventGroupId/index.route'
import { Route as ProgramProgramIdCourseCourseIdIndexRouteImport } from './routes/program/$programId/course/$courseId/index.route'
import { Route as PathPathIdSFlexibleContentIdIndexRouteImport } from './routes/path/$pathId/s/$flexibleContentId/index.route'
import { Route as PathPathIdEventEventGroupIdIndexRouteImport } from './routes/path/$pathId/event/$eventGroupId/index.route'
import { Route as PathPathIdCourseCourseIdIndexRouteImport } from './routes/path/$pathId/course/$courseId/index.route'
import { Route as ManageInsightsDashboardsDashboardIdIndexRouteImport } from './routes/manage/insights/dashboards/$dashboardId/index.route'
import { Route as ProgramProgramIdSFlexibleContentIdFileIdRouteImport } from './routes/program/$programId/s/$flexibleContentId/$fileId.route'
import { Route as ProgramProgramIdCourseCourseIdScormRouteImport } from './routes/program/$programId/course/$courseId/scorm.route'
import { Route as ProgramProgramIdCourseCourseIdNextRouteImport } from './routes/program/$programId/course/$courseId/next.route'
import { Route as ProgramProgramIdCourseCourseIdSplatRouteImport } from './routes/program/$programId/course/$courseId/$.route'
import { Route as PathPathIdSFlexibleContentIdFileIdRouteImport } from './routes/path/$pathId/s/$flexibleContentId/$fileId.route'
import { Route as PathPathIdCourseCourseIdScormRouteImport } from './routes/path/$pathId/course/$courseId/scorm.route'
import { Route as PathPathIdCourseCourseIdNextRouteImport } from './routes/path/$pathId/course/$courseId/next.route'
import { Route as PathPathIdCourseCourseIdSplatRouteImport } from './routes/path/$pathId/course/$courseId/$.route'
import { Route as ManageInsightsDashboardsTemplatesTemplateIdIndexRouteImport } from './routes/manage/insights/dashboards/templates/$templateId/index.route'
import { Route as ProgramProgramIdPathPathIdSFlexibleContentIdIndexRouteImport } from './routes/program/$programId/path/$pathId/s/$flexibleContentId/index.route'
import { Route as ProgramProgramIdPathPathIdEventEventGroupIdIndexRouteImport } from './routes/program/$programId/path/$pathId/event/$eventGroupId/index.route'
import { Route as ProgramProgramIdPathPathIdCourseCourseIdIndexRouteImport } from './routes/program/$programId/path/$pathId/course/$courseId/index.route'
import { Route as ProgramProgramIdPathPathIdSFlexibleContentIdFileIdRouteImport } from './routes/program/$programId/path/$pathId/s/$flexibleContentId/$fileId.route'
import { Route as ProgramProgramIdPathPathIdCourseCourseIdScormRouteImport } from './routes/program/$programId/path/$pathId/course/$courseId/scorm.route'
import { Route as ProgramProgramIdPathPathIdCourseCourseIdNextRouteImport } from './routes/program/$programId/path/$pathId/course/$courseId/next.route'
import { Route as ProgramProgramIdPathPathIdCourseCourseIdSplatRouteImport } from './routes/program/$programId/path/$pathId/course/$courseId/$.route'

// Create Virtual Routes

const ShowcaseIndexLazyImport = createFileRoute('/showcase/')()
const ShowcaseTabularLazyImport = createFileRoute('/showcase/tabular')()
const ShowcaseTablesLazyImport = createFileRoute('/showcase/tables')()
const ShowcaseSkillsSelectModalLazyImport = createFileRoute(
  '/showcase/skills-select-modal',
)()
const ShowcaseSkillsBoardsLazyImport = createFileRoute(
  '/showcase/skills-boards',
)()
const ShowcaseSkillsBadgesLazyImport = createFileRoute(
  '/showcase/skills-badges',
)()
const ShowcaseSkillsAchievementsModalLazyImport = createFileRoute(
  '/showcase/skills-achievements-modal',
)()
const ShowcaseSkillRecommendationLazyImport = createFileRoute(
  '/showcase/skill-recommendation',
)()
const ShowcaseNotificationsLazyImport = createFileRoute(
  '/showcase/notifications',
)()
const ShowcaseLoadingSpinnerLazyImport = createFileRoute(
  '/showcase/loading-spinner',
)()
const ShowcaseLilStackLazyImport = createFileRoute('/showcase/lil-stack')()
const ShowcaseLayoutKitLazyImport = createFileRoute('/showcase/layout-kit')()
const ShowcaseInsightsSqlLazyImport = createFileRoute(
  '/showcase/insights-sql',
)()
const ShowcaseImagesLazyImport = createFileRoute('/showcase/images')()
const ShowcaseGenerateIdsLazyImport = createFileRoute(
  '/showcase/generate-ids',
)()
const ShowcaseFiltersLazyImport = createFileRoute('/showcase/filters')()
const ShowcaseExperimentalEditorLazyImport = createFileRoute(
  '/showcase/experimental-editor',
)()
const ShowcaseDatesLazyImport = createFileRoute('/showcase/dates')()
const ShowcaseContentSkillsSettingsLazyImport = createFileRoute(
  '/showcase/content-skills-settings',
)()
const ShowcaseContentPreviewLazyImport = createFileRoute(
  '/showcase/content-preview',
)()
const ShowcaseActivityLazyImport = createFileRoute('/showcase/activity')()
const ShowcaseGraphqlUserTableLazyImport = createFileRoute(
  '/showcase/graphql/user-table',
)()

// Create/Update Routes

const SelectEditionRouteRoute = SelectEditionRouteImport.update({
  path: '/select-edition',
  getParentRoute: () => rootRoute,
} as any)

const DebugaccessRouteRoute = DebugaccessRouteImport.update({
  path: '/debugaccess',
  getParentRoute: () => rootRoute,
} as any)

const ContentNotFoundRouteRoute = ContentNotFoundRouteImport.update({
  path: '/content-not-found',
  getParentRoute: () => rootRoute,
} as any)

const CertificateV2RouteRoute = CertificateV2RouteImport.update({
  path: '/certificate-v2',
  getParentRoute: () => rootRoute,
} as any)

const BrowseRouteRoute = BrowseRouteImport.update({
  path: '/browse',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticateRouteRoute = AuthenticateRouteImport.update({
  path: '/authenticate',
  getParentRoute: () => rootRoute,
} as any)

const AccountActionRouteRoute = AccountActionRouteImport.update({
  path: '/account-action',
  getParentRoute: () => rootRoute,
} as any)

const AccessDeniedRouteRoute = AccessDeniedRouteImport.update({
  path: '/access-denied',
  getParentRoute: () => rootRoute,
} as any)

const AcceptInviteRouteRoute = AcceptInviteRouteImport.update({
  path: '/accept-invite',
  getParentRoute: () => rootRoute,
} as any)

const R404RouteRoute = R404RouteImport.update({
  path: '/404',
  getParentRoute: () => rootRoute,
} as any)

const IndexRouteRoute = IndexRouteImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ShowcaseIndexLazyRoute = ShowcaseIndexLazyImport.update({
  path: '/showcase/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/index.lazy').then((d) => d.Route),
)

const LearnIndexRouteRoute = LearnIndexRouteImport.update({
  path: '/learn/',
  getParentRoute: () => rootRoute,
} as any)

const CreateIndexRouteRoute = CreateIndexRouteImport.update({
  path: '/create/',
  getParentRoute: () => rootRoute,
} as any)

const CreateNewIndexRouteRoute = CreateNewIndexRouteImport.update({
  path: '/create-new/',
  getParentRoute: () => rootRoute,
} as any)

const ShowcaseTabularLazyRoute = ShowcaseTabularLazyImport.update({
  path: '/showcase/tabular',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/tabular.lazy').then((d) => d.Route),
)

const ShowcaseTablesLazyRoute = ShowcaseTablesLazyImport.update({
  path: '/showcase/tables',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/tables.lazy').then((d) => d.Route),
)

const ShowcaseSkillsSelectModalLazyRoute =
  ShowcaseSkillsSelectModalLazyImport.update({
    path: '/showcase/skills-select-modal',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/showcase/skills-select-modal.lazy').then((d) => d.Route),
  )

const ShowcaseSkillsBoardsLazyRoute = ShowcaseSkillsBoardsLazyImport.update({
  path: '/showcase/skills-boards',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/skills-boards.lazy').then((d) => d.Route),
)

const ShowcaseSkillsBadgesLazyRoute = ShowcaseSkillsBadgesLazyImport.update({
  path: '/showcase/skills-badges',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/skills-badges.lazy').then((d) => d.Route),
)

const ShowcaseSkillsAchievementsModalLazyRoute =
  ShowcaseSkillsAchievementsModalLazyImport.update({
    path: '/showcase/skills-achievements-modal',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/showcase/skills-achievements-modal.lazy').then(
      (d) => d.Route,
    ),
  )

const ShowcaseSkillRecommendationLazyRoute =
  ShowcaseSkillRecommendationLazyImport.update({
    path: '/showcase/skill-recommendation',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/showcase/skill-recommendation.lazy').then((d) => d.Route),
  )

const ShowcaseNotificationsLazyRoute = ShowcaseNotificationsLazyImport.update({
  path: '/showcase/notifications',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/notifications.lazy').then((d) => d.Route),
)

const ShowcaseLoadingSpinnerLazyRoute = ShowcaseLoadingSpinnerLazyImport.update(
  {
    path: '/showcase/loading-spinner',
    getParentRoute: () => rootRoute,
  } as any,
).lazy(() =>
  import('./routes/showcase/loading-spinner.lazy').then((d) => d.Route),
)

const ShowcaseLilStackLazyRoute = ShowcaseLilStackLazyImport.update({
  path: '/showcase/lil-stack',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/lil-stack.lazy').then((d) => d.Route),
)

const ShowcaseLayoutKitLazyRoute = ShowcaseLayoutKitLazyImport.update({
  path: '/showcase/layout-kit',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/layout-kit.lazy').then((d) => d.Route),
)

const ShowcaseInsightsSqlLazyRoute = ShowcaseInsightsSqlLazyImport.update({
  path: '/showcase/insights-sql',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/insights-sql.lazy').then((d) => d.Route),
)

const ShowcaseImagesLazyRoute = ShowcaseImagesLazyImport.update({
  path: '/showcase/images',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/images.lazy').then((d) => d.Route),
)

const ShowcaseGenerateIdsLazyRoute = ShowcaseGenerateIdsLazyImport.update({
  path: '/showcase/generate-ids',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/generate-ids.lazy').then((d) => d.Route),
)

const ShowcaseFiltersLazyRoute = ShowcaseFiltersLazyImport.update({
  path: '/showcase/filters',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/filters.lazy').then((d) => d.Route),
)

const ShowcaseExperimentalEditorLazyRoute =
  ShowcaseExperimentalEditorLazyImport.update({
    path: '/showcase/experimental-editor',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/showcase/experimental-editor.lazy').then((d) => d.Route),
  )

const ShowcaseDatesLazyRoute = ShowcaseDatesLazyImport.update({
  path: '/showcase/dates',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/dates.lazy').then((d) => d.Route),
)

const ShowcaseContentSkillsSettingsLazyRoute =
  ShowcaseContentSkillsSettingsLazyImport.update({
    path: '/showcase/content-skills-settings',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/showcase/content-skills-settings.lazy').then(
      (d) => d.Route,
    ),
  )

const ShowcaseContentPreviewLazyRoute = ShowcaseContentPreviewLazyImport.update(
  {
    path: '/showcase/content-preview',
    getParentRoute: () => rootRoute,
  } as any,
).lazy(() =>
  import('./routes/showcase/content-preview.lazy').then((d) => d.Route),
)

const ShowcaseActivityLazyRoute = ShowcaseActivityLazyImport.update({
  path: '/showcase/activity',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/showcase/activity.lazy').then((d) => d.Route),
)

const SkillSkillIdRouteRoute = SkillSkillIdRouteImport.update({
  path: '/skill/$skillId',
  getParentRoute: () => rootRoute,
} as any)

const SettingsNotificationsRouteRoute = SettingsNotificationsRouteImport.update(
  {
    path: '/settings/notifications',
    getParentRoute: () => rootRoute,
  } as any,
)

const SettingsGeneralRouteRoute = SettingsGeneralRouteImport.update({
  path: '/settings/general',
  getParentRoute: () => rootRoute,
} as any)

const SettingsBrandingRouteRoute = SettingsBrandingRouteImport.update({
  path: '/settings/branding',
  getParentRoute: () => rootRoute,
} as any)

const ScormDispatchSplatRouteRoute = ScormDispatchSplatRouteImport.update({
  path: '/scorm-dispatch/$',
  getParentRoute: () => rootRoute,
} as any)

const RecoveryUsersRouteRoute = RecoveryUsersRouteImport.update({
  path: '/recovery/users',
  getParentRoute: () => rootRoute,
} as any)

const RecoveryLivesessionsRouteRoute = RecoveryLivesessionsRouteImport.update({
  path: '/recovery/livesessions',
  getParentRoute: () => rootRoute,
} as any)

const RecoveryCoursesRouteRoute = RecoveryCoursesRouteImport.update({
  path: '/recovery/courses',
  getParentRoute: () => rootRoute,
} as any)

const RSplatRouteRoute = RSplatRouteImport.update({
  path: '/r/$',
  getParentRoute: () => rootRoute,
} as any)

const ManageReportsRouteRoute = ManageReportsRouteImport.update({
  path: '/manage/reports',
  getParentRoute: () => rootRoute,
} as any)

const ManageOverviewRouteRoute = ManageOverviewRouteImport.update({
  path: '/manage/overview',
  getParentRoute: () => rootRoute,
} as any)

const ManageContentRouteRoute = ManageContentRouteImport.update({
  path: '/manage/content',
  getParentRoute: () => rootRoute,
} as any)

const GroupInviteTokenRouteRoute = GroupInviteTokenRouteImport.update({
  path: '/group-invite/$token',
  getParentRoute: () => rootRoute,
} as any)

const DebugErrorSyncRouteRoute = DebugErrorSyncRouteImport.update({
  path: '/debug/error-sync',
  getParentRoute: () => rootRoute,
} as any)

const DebugErrorAsyncRouteRoute = DebugErrorAsyncRouteImport.update({
  path: '/debug/error-async',
  getParentRoute: () => rootRoute,
} as any)

const DebugCollaborationRouteRoute = DebugCollaborationRouteImport.update({
  path: '/debug/collaboration',
  getParentRoute: () => rootRoute,
} as any)

const AdminErrorRouteRoute = AdminErrorRouteImport.update({
  path: '/admin/error',
  getParentRoute: () => rootRoute,
} as any)

const TTeamspaceIdIndexRouteRoute = TTeamspaceIdIndexRouteImport.update({
  path: '/t/$teamspaceId/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsApiIndexRouteRoute = SettingsApiIndexRouteImport.update({
  path: '/settings/api/',
  getParentRoute: () => rootRoute,
} as any)

const SFlexibleContentIdIndexRouteRoute =
  SFlexibleContentIdIndexRouteImport.update({
    path: '/s/$flexibleContentId/',
    getParentRoute: () => rootRoute,
  } as any)

const RoomLiveRoomIdIndexRouteRoute = RoomLiveRoomIdIndexRouteImport.update({
  path: '/room/$liveRoomId/',
  getParentRoute: () => rootRoute,
} as any)

const ProgramProgramIdIndexRouteRoute = ProgramProgramIdIndexRouteImport.update(
  {
    path: '/program/$programId/',
    getParentRoute: () => rootRoute,
  } as any,
)

const PathPathIdIndexRouteRoute = PathPathIdIndexRouteImport.update({
  path: '/path/$pathId/',
  getParentRoute: () => rootRoute,
} as any)

const ManageUsersIndexRouteRoute = ManageUsersIndexRouteImport.update({
  path: '/manage/users/',
  getParentRoute: () => rootRoute,
} as any)

const ManageUserGroupsIndexRouteRoute = ManageUserGroupsIndexRouteImport.update(
  {
    path: '/manage/user-groups/',
    getParentRoute: () => rootRoute,
  } as any,
)

const ManageTagsIndexRouteRoute = ManageTagsIndexRouteImport.update({
  path: '/manage/tags/',
  getParentRoute: () => rootRoute,
} as any)

const ManageSkillsIndexRouteRoute = ManageSkillsIndexRouteImport.update({
  path: '/manage/skills/',
  getParentRoute: () => rootRoute,
} as any)

const ManageProgramsIndexRouteRoute = ManageProgramsIndexRouteImport.update({
  path: '/manage/programs/',
  getParentRoute: () => rootRoute,
} as any)

const ManageInsightsIndexRouteRoute = ManageInsightsIndexRouteImport.update({
  path: '/manage/insights/',
  getParentRoute: () => rootRoute,
} as any)

const ManageInPersonEventsIndexRouteRoute =
  ManageInPersonEventsIndexRouteImport.update({
    path: '/manage/in-person-events/',
    getParentRoute: () => rootRoute,
  } as any)

const ManageExercisesIndexRouteRoute = ManageExercisesIndexRouteImport.update({
  path: '/manage/exercises/',
  getParentRoute: () => rootRoute,
} as any)

const ManageCertificatesIndexRouteRoute =
  ManageCertificatesIndexRouteImport.update({
    path: '/manage/certificates/',
    getParentRoute: () => rootRoute,
  } as any)

const LLiveSessionIdIndexRouteRoute = LLiveSessionIdIndexRouteImport.update({
  path: '/l/$liveSessionId/',
  getParentRoute: () => rootRoute,
} as any)

const EventEventGroupIdIndexRouteRoute =
  EventEventGroupIdIndexRouteImport.update({
    path: '/event/$eventGroupId/',
    getParentRoute: () => rootRoute,
  } as any)

const CourseCourseIdIndexRouteRoute = CourseCourseIdIndexRouteImport.update({
  path: '/course/$courseId/',
  getParentRoute: () => rootRoute,
} as any)

const AdminPathsPlaygroundIndexRouteRoute =
  AdminPathsPlaygroundIndexRouteImport.update({
    path: '/admin/paths-playground/',
    getParentRoute: () => rootRoute,
  } as any)

const ShowcaseGraphqlUserTableLazyRoute =
  ShowcaseGraphqlUserTableLazyImport.update({
    path: '/showcase/graphql/user-table',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/showcase/graphql/user-table.lazy').then((d) => d.Route),
  )

const TTeamspaceIdFolderIdRouteRoute = TTeamspaceIdFolderIdRouteImport.update({
  path: '/t/$teamspaceId/$folderId',
  getParentRoute: () => rootRoute,
} as any)

const SettingsApiApiClientIdRouteRoute =
  SettingsApiApiClientIdRouteImport.update({
    path: '/settings/api/$apiClientId',
    getParentRoute: () => rootRoute,
  } as any)

const SFlexibleContentIdFileIdRouteRoute =
  SFlexibleContentIdFileIdRouteImport.update({
    path: '/s/$flexibleContentId/$fileId',
    getParentRoute: () => rootRoute,
  } as any)

const ManageXApiXApiServerIdRouteRoute =
  ManageXApiXApiServerIdRouteImport.update({
    path: '/manage/x-api/$xApiServerId',
    getParentRoute: () => rootRoute,
  } as any)

const ManageUsersUserIdRouteRoute = ManageUsersUserIdRouteImport.update({
  path: '/manage/users/$userId',
  getParentRoute: () => rootRoute,
} as any)

const ManageUserGroupsGroupIdRouteRoute =
  ManageUserGroupsGroupIdRouteImport.update({
    path: '/manage/user-groups/$groupId',
    getParentRoute: () => rootRoute,
  } as any)

const ManageTagsTagIdRouteRoute = ManageTagsTagIdRouteImport.update({
  path: '/manage/tags/$tagId',
  getParentRoute: () => rootRoute,
} as any)

const ManageProgramsProgramIdRouteRoute =
  ManageProgramsProgramIdRouteImport.update({
    path: '/manage/programs/$programId',
    getParentRoute: () => rootRoute,
  } as any)

const ManagePathsPathIdRouteRoute = ManagePathsPathIdRouteImport.update({
  path: '/manage/paths/$pathId',
  getParentRoute: () => rootRoute,
} as any)

const ManageExercisesExerciseIdRouteRoute =
  ManageExercisesExerciseIdRouteImport.update({
    path: '/manage/exercises/$exerciseId',
    getParentRoute: () => rootRoute,
  } as any)

const ManageEventsLiveSessionIdRouteRoute =
  ManageEventsLiveSessionIdRouteImport.update({
    path: '/manage/events/$liveSessionId',
    getParentRoute: () => rootRoute,
  } as any)

const ManageCoursesCourseIdRouteRoute = ManageCoursesCourseIdRouteImport.update(
  {
    path: '/manage/courses/$courseId',
    getParentRoute: () => rootRoute,
  } as any,
)

const ManageCourseGroupCourseGroupIdRouteRoute =
  ManageCourseGroupCourseGroupIdRouteImport.update({
    path: '/manage/course-group/$courseGroupId',
    getParentRoute: () => rootRoute,
  } as any)

const ManageCertificatesCertificateIdRouteRoute =
  ManageCertificatesCertificateIdRouteImport.update({
    path: '/manage/certificates/$certificateId',
    getParentRoute: () => rootRoute,
  } as any)

const HistorySSplatRouteRoute = HistorySSplatRouteImport.update({
  path: '/history/s/$',
  getParentRoute: () => rootRoute,
} as any)

const HistoryLSplatRouteRoute = HistoryLSplatRouteImport.update({
  path: '/history/l/$',
  getParentRoute: () => rootRoute,
} as any)

const CreateSNewRouteRoute = CreateSNewRouteImport.update({
  path: '/create/s/new',
  getParentRoute: () => rootRoute,
} as any)

const CreateSSplatRouteRoute = CreateSSplatRouteImport.update({
  path: '/create/s/$',
  getParentRoute: () => rootRoute,
} as any)

const CreateLNewRouteRoute = CreateLNewRouteImport.update({
  path: '/create/l/new',
  getParentRoute: () => rootRoute,
} as any)

const CreateLSplatRouteRoute = CreateLSplatRouteImport.update({
  path: '/create/l/$',
  getParentRoute: () => rootRoute,
} as any)

const CourseCourseIdScormRouteRoute = CourseCourseIdScormRouteImport.update({
  path: '/course/$courseId/scorm',
  getParentRoute: () => rootRoute,
} as any)

const CourseCourseIdNextRouteRoute = CourseCourseIdNextRouteImport.update({
  path: '/course/$courseId/next',
  getParentRoute: () => rootRoute,
} as any)

const CourseCourseIdSplatRouteRoute = CourseCourseIdSplatRouteImport.update({
  path: '/course/$courseId/$',
  getParentRoute: () => rootRoute,
} as any)

const ManageInsightsDashboardsIndexRouteRoute =
  ManageInsightsDashboardsIndexRouteImport.update({
    path: '/manage/insights/dashboards/',
    getParentRoute: () => rootRoute,
  } as any)

const ManageInPersonEventsEventGroupIdIndexRouteRoute =
  ManageInPersonEventsEventGroupIdIndexRouteImport.update({
    path: '/manage/in-person-events/$eventGroupId/',
    getParentRoute: () => rootRoute,
  } as any)

const CheckInEventGroupIdEventIdIndexRouteRoute =
  CheckInEventGroupIdEventIdIndexRouteImport.update({
    path: '/check-in/$eventGroupId/$eventId/',
    getParentRoute: () => rootRoute,
  } as any)

const ManageUserUserIdExportTranscriptRouteRoute =
  ManageUserUserIdExportTranscriptRouteImport.update({
    path: '/manage/user/$userId/export-transcript',
    getParentRoute: () => rootRoute,
  } as any)

const ManageInPersonEventsEventGroupIdCalendarEventIdRouteRoute =
  ManageInPersonEventsEventGroupIdCalendarEventIdRouteImport.update({
    path: '/manage/in-person-events/$eventGroupId/$calendarEventId',
    getParentRoute: () => rootRoute,
  } as any)

const CreateExportSSelfPacedContentIdRouteRoute =
  CreateExportSSelfPacedContentIdRouteImport.update({
    path: '/create/export/s/$selfPacedContentId',
    getParentRoute: () => rootRoute,
  } as any)

const CreateExportLLiveContentIdRouteRoute =
  CreateExportLLiveContentIdRouteImport.update({
    path: '/create/export/l/$liveContentId',
    getParentRoute: () => rootRoute,
  } as any)

const CheckInEventGroupIdEventIdQrRouteRoute =
  CheckInEventGroupIdEventIdQrRouteImport.update({
    path: '/check-in/$eventGroupId/$eventId/qr',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdSFlexibleContentIdIndexRouteRoute =
  ProgramProgramIdSFlexibleContentIdIndexRouteImport.update({
    path: '/program/$programId/s/$flexibleContentId/',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdPathPathIdIndexRouteRoute =
  ProgramProgramIdPathPathIdIndexRouteImport.update({
    path: '/program/$programId/path/$pathId/',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdEventEventGroupIdIndexRouteRoute =
  ProgramProgramIdEventEventGroupIdIndexRouteImport.update({
    path: '/program/$programId/event/$eventGroupId/',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdCourseCourseIdIndexRouteRoute =
  ProgramProgramIdCourseCourseIdIndexRouteImport.update({
    path: '/program/$programId/course/$courseId/',
    getParentRoute: () => rootRoute,
  } as any)

const PathPathIdSFlexibleContentIdIndexRouteRoute =
  PathPathIdSFlexibleContentIdIndexRouteImport.update({
    path: '/path/$pathId/s/$flexibleContentId/',
    getParentRoute: () => rootRoute,
  } as any)

const PathPathIdEventEventGroupIdIndexRouteRoute =
  PathPathIdEventEventGroupIdIndexRouteImport.update({
    path: '/path/$pathId/event/$eventGroupId/',
    getParentRoute: () => rootRoute,
  } as any)

const PathPathIdCourseCourseIdIndexRouteRoute =
  PathPathIdCourseCourseIdIndexRouteImport.update({
    path: '/path/$pathId/course/$courseId/',
    getParentRoute: () => rootRoute,
  } as any)

const ManageInsightsDashboardsDashboardIdIndexRouteRoute =
  ManageInsightsDashboardsDashboardIdIndexRouteImport.update({
    path: '/manage/insights/dashboards/$dashboardId/',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdSFlexibleContentIdFileIdRouteRoute =
  ProgramProgramIdSFlexibleContentIdFileIdRouteImport.update({
    path: '/program/$programId/s/$flexibleContentId/$fileId',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdCourseCourseIdScormRouteRoute =
  ProgramProgramIdCourseCourseIdScormRouteImport.update({
    path: '/program/$programId/course/$courseId/scorm',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdCourseCourseIdNextRouteRoute =
  ProgramProgramIdCourseCourseIdNextRouteImport.update({
    path: '/program/$programId/course/$courseId/next',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdCourseCourseIdSplatRouteRoute =
  ProgramProgramIdCourseCourseIdSplatRouteImport.update({
    path: '/program/$programId/course/$courseId/$',
    getParentRoute: () => rootRoute,
  } as any)

const PathPathIdSFlexibleContentIdFileIdRouteRoute =
  PathPathIdSFlexibleContentIdFileIdRouteImport.update({
    path: '/path/$pathId/s/$flexibleContentId/$fileId',
    getParentRoute: () => rootRoute,
  } as any)

const PathPathIdCourseCourseIdScormRouteRoute =
  PathPathIdCourseCourseIdScormRouteImport.update({
    path: '/path/$pathId/course/$courseId/scorm',
    getParentRoute: () => rootRoute,
  } as any)

const PathPathIdCourseCourseIdNextRouteRoute =
  PathPathIdCourseCourseIdNextRouteImport.update({
    path: '/path/$pathId/course/$courseId/next',
    getParentRoute: () => rootRoute,
  } as any)

const PathPathIdCourseCourseIdSplatRouteRoute =
  PathPathIdCourseCourseIdSplatRouteImport.update({
    path: '/path/$pathId/course/$courseId/$',
    getParentRoute: () => rootRoute,
  } as any)

const ManageInsightsDashboardsTemplatesTemplateIdIndexRouteRoute =
  ManageInsightsDashboardsTemplatesTemplateIdIndexRouteImport.update({
    path: '/manage/insights/dashboards/templates/$templateId/',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdPathPathIdSFlexibleContentIdIndexRouteRoute =
  ProgramProgramIdPathPathIdSFlexibleContentIdIndexRouteImport.update({
    path: '/program/$programId/path/$pathId/s/$flexibleContentId/',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdPathPathIdEventEventGroupIdIndexRouteRoute =
  ProgramProgramIdPathPathIdEventEventGroupIdIndexRouteImport.update({
    path: '/program/$programId/path/$pathId/event/$eventGroupId/',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdPathPathIdCourseCourseIdIndexRouteRoute =
  ProgramProgramIdPathPathIdCourseCourseIdIndexRouteImport.update({
    path: '/program/$programId/path/$pathId/course/$courseId/',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdPathPathIdSFlexibleContentIdFileIdRouteRoute =
  ProgramProgramIdPathPathIdSFlexibleContentIdFileIdRouteImport.update({
    path: '/program/$programId/path/$pathId/s/$flexibleContentId/$fileId',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdPathPathIdCourseCourseIdScormRouteRoute =
  ProgramProgramIdPathPathIdCourseCourseIdScormRouteImport.update({
    path: '/program/$programId/path/$pathId/course/$courseId/scorm',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdPathPathIdCourseCourseIdNextRouteRoute =
  ProgramProgramIdPathPathIdCourseCourseIdNextRouteImport.update({
    path: '/program/$programId/path/$pathId/course/$courseId/next',
    getParentRoute: () => rootRoute,
  } as any)

const ProgramProgramIdPathPathIdCourseCourseIdSplatRouteRoute =
  ProgramProgramIdPathPathIdCourseCourseIdSplatRouteImport.update({
    path: '/program/$programId/path/$pathId/course/$courseId/$',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRoute
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRoute
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRoute
    }
    '/account-action': {
      id: '/account-action'
      path: '/account-action'
      fullPath: '/account-action'
      preLoaderRoute: typeof AccountActionRouteImport
      parentRoute: typeof rootRoute
    }
    '/authenticate': {
      id: '/authenticate'
      path: '/authenticate'
      fullPath: '/authenticate'
      preLoaderRoute: typeof AuthenticateRouteImport
      parentRoute: typeof rootRoute
    }
    '/browse': {
      id: '/browse'
      path: '/browse'
      fullPath: '/browse'
      preLoaderRoute: typeof BrowseRouteImport
      parentRoute: typeof rootRoute
    }
    '/certificate-v2': {
      id: '/certificate-v2'
      path: '/certificate-v2'
      fullPath: '/certificate-v2'
      preLoaderRoute: typeof CertificateV2RouteImport
      parentRoute: typeof rootRoute
    }
    '/content-not-found': {
      id: '/content-not-found'
      path: '/content-not-found'
      fullPath: '/content-not-found'
      preLoaderRoute: typeof ContentNotFoundRouteImport
      parentRoute: typeof rootRoute
    }
    '/debugaccess': {
      id: '/debugaccess'
      path: '/debugaccess'
      fullPath: '/debugaccess'
      preLoaderRoute: typeof DebugaccessRouteImport
      parentRoute: typeof rootRoute
    }
    '/select-edition': {
      id: '/select-edition'
      path: '/select-edition'
      fullPath: '/select-edition'
      preLoaderRoute: typeof SelectEditionRouteImport
      parentRoute: typeof rootRoute
    }
    '/admin/error': {
      id: '/admin/error'
      path: '/admin/error'
      fullPath: '/admin/error'
      preLoaderRoute: typeof AdminErrorRouteImport
      parentRoute: typeof rootRoute
    }
    '/debug/collaboration': {
      id: '/debug/collaboration'
      path: '/debug/collaboration'
      fullPath: '/debug/collaboration'
      preLoaderRoute: typeof DebugCollaborationRouteImport
      parentRoute: typeof rootRoute
    }
    '/debug/error-async': {
      id: '/debug/error-async'
      path: '/debug/error-async'
      fullPath: '/debug/error-async'
      preLoaderRoute: typeof DebugErrorAsyncRouteImport
      parentRoute: typeof rootRoute
    }
    '/debug/error-sync': {
      id: '/debug/error-sync'
      path: '/debug/error-sync'
      fullPath: '/debug/error-sync'
      preLoaderRoute: typeof DebugErrorSyncRouteImport
      parentRoute: typeof rootRoute
    }
    '/group-invite/$token': {
      id: '/group-invite/$token'
      path: '/group-invite/$token'
      fullPath: '/group-invite/$token'
      preLoaderRoute: typeof GroupInviteTokenRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/content': {
      id: '/manage/content'
      path: '/manage/content'
      fullPath: '/manage/content'
      preLoaderRoute: typeof ManageContentRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/overview': {
      id: '/manage/overview'
      path: '/manage/overview'
      fullPath: '/manage/overview'
      preLoaderRoute: typeof ManageOverviewRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/reports': {
      id: '/manage/reports'
      path: '/manage/reports'
      fullPath: '/manage/reports'
      preLoaderRoute: typeof ManageReportsRouteImport
      parentRoute: typeof rootRoute
    }
    '/r/$': {
      id: '/r/$'
      path: '/r/$'
      fullPath: '/r/$'
      preLoaderRoute: typeof RSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/recovery/courses': {
      id: '/recovery/courses'
      path: '/recovery/courses'
      fullPath: '/recovery/courses'
      preLoaderRoute: typeof RecoveryCoursesRouteImport
      parentRoute: typeof rootRoute
    }
    '/recovery/livesessions': {
      id: '/recovery/livesessions'
      path: '/recovery/livesessions'
      fullPath: '/recovery/livesessions'
      preLoaderRoute: typeof RecoveryLivesessionsRouteImport
      parentRoute: typeof rootRoute
    }
    '/recovery/users': {
      id: '/recovery/users'
      path: '/recovery/users'
      fullPath: '/recovery/users'
      preLoaderRoute: typeof RecoveryUsersRouteImport
      parentRoute: typeof rootRoute
    }
    '/scorm-dispatch/$': {
      id: '/scorm-dispatch/$'
      path: '/scorm-dispatch/$'
      fullPath: '/scorm-dispatch/$'
      preLoaderRoute: typeof ScormDispatchSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/settings/branding': {
      id: '/settings/branding'
      path: '/settings/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof SettingsBrandingRouteImport
      parentRoute: typeof rootRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/settings/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof rootRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRoute
    }
    '/skill/$skillId': {
      id: '/skill/$skillId'
      path: '/skill/$skillId'
      fullPath: '/skill/$skillId'
      preLoaderRoute: typeof SkillSkillIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/showcase/activity': {
      id: '/showcase/activity'
      path: '/showcase/activity'
      fullPath: '/showcase/activity'
      preLoaderRoute: typeof ShowcaseActivityLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/content-preview': {
      id: '/showcase/content-preview'
      path: '/showcase/content-preview'
      fullPath: '/showcase/content-preview'
      preLoaderRoute: typeof ShowcaseContentPreviewLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/content-skills-settings': {
      id: '/showcase/content-skills-settings'
      path: '/showcase/content-skills-settings'
      fullPath: '/showcase/content-skills-settings'
      preLoaderRoute: typeof ShowcaseContentSkillsSettingsLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/dates': {
      id: '/showcase/dates'
      path: '/showcase/dates'
      fullPath: '/showcase/dates'
      preLoaderRoute: typeof ShowcaseDatesLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/experimental-editor': {
      id: '/showcase/experimental-editor'
      path: '/showcase/experimental-editor'
      fullPath: '/showcase/experimental-editor'
      preLoaderRoute: typeof ShowcaseExperimentalEditorLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/filters': {
      id: '/showcase/filters'
      path: '/showcase/filters'
      fullPath: '/showcase/filters'
      preLoaderRoute: typeof ShowcaseFiltersLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/generate-ids': {
      id: '/showcase/generate-ids'
      path: '/showcase/generate-ids'
      fullPath: '/showcase/generate-ids'
      preLoaderRoute: typeof ShowcaseGenerateIdsLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/images': {
      id: '/showcase/images'
      path: '/showcase/images'
      fullPath: '/showcase/images'
      preLoaderRoute: typeof ShowcaseImagesLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/insights-sql': {
      id: '/showcase/insights-sql'
      path: '/showcase/insights-sql'
      fullPath: '/showcase/insights-sql'
      preLoaderRoute: typeof ShowcaseInsightsSqlLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/layout-kit': {
      id: '/showcase/layout-kit'
      path: '/showcase/layout-kit'
      fullPath: '/showcase/layout-kit'
      preLoaderRoute: typeof ShowcaseLayoutKitLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/lil-stack': {
      id: '/showcase/lil-stack'
      path: '/showcase/lil-stack'
      fullPath: '/showcase/lil-stack'
      preLoaderRoute: typeof ShowcaseLilStackLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/loading-spinner': {
      id: '/showcase/loading-spinner'
      path: '/showcase/loading-spinner'
      fullPath: '/showcase/loading-spinner'
      preLoaderRoute: typeof ShowcaseLoadingSpinnerLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/notifications': {
      id: '/showcase/notifications'
      path: '/showcase/notifications'
      fullPath: '/showcase/notifications'
      preLoaderRoute: typeof ShowcaseNotificationsLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/skill-recommendation': {
      id: '/showcase/skill-recommendation'
      path: '/showcase/skill-recommendation'
      fullPath: '/showcase/skill-recommendation'
      preLoaderRoute: typeof ShowcaseSkillRecommendationLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/skills-achievements-modal': {
      id: '/showcase/skills-achievements-modal'
      path: '/showcase/skills-achievements-modal'
      fullPath: '/showcase/skills-achievements-modal'
      preLoaderRoute: typeof ShowcaseSkillsAchievementsModalLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/skills-badges': {
      id: '/showcase/skills-badges'
      path: '/showcase/skills-badges'
      fullPath: '/showcase/skills-badges'
      preLoaderRoute: typeof ShowcaseSkillsBadgesLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/skills-boards': {
      id: '/showcase/skills-boards'
      path: '/showcase/skills-boards'
      fullPath: '/showcase/skills-boards'
      preLoaderRoute: typeof ShowcaseSkillsBoardsLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/skills-select-modal': {
      id: '/showcase/skills-select-modal'
      path: '/showcase/skills-select-modal'
      fullPath: '/showcase/skills-select-modal'
      preLoaderRoute: typeof ShowcaseSkillsSelectModalLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/tables': {
      id: '/showcase/tables'
      path: '/showcase/tables'
      fullPath: '/showcase/tables'
      preLoaderRoute: typeof ShowcaseTablesLazyImport
      parentRoute: typeof rootRoute
    }
    '/showcase/tabular': {
      id: '/showcase/tabular'
      path: '/showcase/tabular'
      fullPath: '/showcase/tabular'
      preLoaderRoute: typeof ShowcaseTabularLazyImport
      parentRoute: typeof rootRoute
    }
    '/create-new/': {
      id: '/create-new/'
      path: '/create-new'
      fullPath: '/create-new'
      preLoaderRoute: typeof CreateNewIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/create/': {
      id: '/create/'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/learn/': {
      id: '/learn/'
      path: '/learn'
      fullPath: '/learn'
      preLoaderRoute: typeof LearnIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/showcase/': {
      id: '/showcase/'
      path: '/showcase'
      fullPath: '/showcase'
      preLoaderRoute: typeof ShowcaseIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/course/$courseId/$': {
      id: '/course/$courseId/$'
      path: '/course/$courseId/$'
      fullPath: '/course/$courseId/$'
      preLoaderRoute: typeof CourseCourseIdSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/course/$courseId/next': {
      id: '/course/$courseId/next'
      path: '/course/$courseId/next'
      fullPath: '/course/$courseId/next'
      preLoaderRoute: typeof CourseCourseIdNextRouteImport
      parentRoute: typeof rootRoute
    }
    '/course/$courseId/scorm': {
      id: '/course/$courseId/scorm'
      path: '/course/$courseId/scorm'
      fullPath: '/course/$courseId/scorm'
      preLoaderRoute: typeof CourseCourseIdScormRouteImport
      parentRoute: typeof rootRoute
    }
    '/create/l/$': {
      id: '/create/l/$'
      path: '/create/l/$'
      fullPath: '/create/l/$'
      preLoaderRoute: typeof CreateLSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/create/l/new': {
      id: '/create/l/new'
      path: '/create/l/new'
      fullPath: '/create/l/new'
      preLoaderRoute: typeof CreateLNewRouteImport
      parentRoute: typeof rootRoute
    }
    '/create/s/$': {
      id: '/create/s/$'
      path: '/create/s/$'
      fullPath: '/create/s/$'
      preLoaderRoute: typeof CreateSSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/create/s/new': {
      id: '/create/s/new'
      path: '/create/s/new'
      fullPath: '/create/s/new'
      preLoaderRoute: typeof CreateSNewRouteImport
      parentRoute: typeof rootRoute
    }
    '/history/l/$': {
      id: '/history/l/$'
      path: '/history/l/$'
      fullPath: '/history/l/$'
      preLoaderRoute: typeof HistoryLSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/history/s/$': {
      id: '/history/s/$'
      path: '/history/s/$'
      fullPath: '/history/s/$'
      preLoaderRoute: typeof HistorySSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/certificates/$certificateId': {
      id: '/manage/certificates/$certificateId'
      path: '/manage/certificates/$certificateId'
      fullPath: '/manage/certificates/$certificateId'
      preLoaderRoute: typeof ManageCertificatesCertificateIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/course-group/$courseGroupId': {
      id: '/manage/course-group/$courseGroupId'
      path: '/manage/course-group/$courseGroupId'
      fullPath: '/manage/course-group/$courseGroupId'
      preLoaderRoute: typeof ManageCourseGroupCourseGroupIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/courses/$courseId': {
      id: '/manage/courses/$courseId'
      path: '/manage/courses/$courseId'
      fullPath: '/manage/courses/$courseId'
      preLoaderRoute: typeof ManageCoursesCourseIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/events/$liveSessionId': {
      id: '/manage/events/$liveSessionId'
      path: '/manage/events/$liveSessionId'
      fullPath: '/manage/events/$liveSessionId'
      preLoaderRoute: typeof ManageEventsLiveSessionIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/exercises/$exerciseId': {
      id: '/manage/exercises/$exerciseId'
      path: '/manage/exercises/$exerciseId'
      fullPath: '/manage/exercises/$exerciseId'
      preLoaderRoute: typeof ManageExercisesExerciseIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/paths/$pathId': {
      id: '/manage/paths/$pathId'
      path: '/manage/paths/$pathId'
      fullPath: '/manage/paths/$pathId'
      preLoaderRoute: typeof ManagePathsPathIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/programs/$programId': {
      id: '/manage/programs/$programId'
      path: '/manage/programs/$programId'
      fullPath: '/manage/programs/$programId'
      preLoaderRoute: typeof ManageProgramsProgramIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/tags/$tagId': {
      id: '/manage/tags/$tagId'
      path: '/manage/tags/$tagId'
      fullPath: '/manage/tags/$tagId'
      preLoaderRoute: typeof ManageTagsTagIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/user-groups/$groupId': {
      id: '/manage/user-groups/$groupId'
      path: '/manage/user-groups/$groupId'
      fullPath: '/manage/user-groups/$groupId'
      preLoaderRoute: typeof ManageUserGroupsGroupIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/users/$userId': {
      id: '/manage/users/$userId'
      path: '/manage/users/$userId'
      fullPath: '/manage/users/$userId'
      preLoaderRoute: typeof ManageUsersUserIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/x-api/$xApiServerId': {
      id: '/manage/x-api/$xApiServerId'
      path: '/manage/x-api/$xApiServerId'
      fullPath: '/manage/x-api/$xApiServerId'
      preLoaderRoute: typeof ManageXApiXApiServerIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/s/$flexibleContentId/$fileId': {
      id: '/s/$flexibleContentId/$fileId'
      path: '/s/$flexibleContentId/$fileId'
      fullPath: '/s/$flexibleContentId/$fileId'
      preLoaderRoute: typeof SFlexibleContentIdFileIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/settings/api/$apiClientId': {
      id: '/settings/api/$apiClientId'
      path: '/settings/api/$apiClientId'
      fullPath: '/settings/api/$apiClientId'
      preLoaderRoute: typeof SettingsApiApiClientIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/t/$teamspaceId/$folderId': {
      id: '/t/$teamspaceId/$folderId'
      path: '/t/$teamspaceId/$folderId'
      fullPath: '/t/$teamspaceId/$folderId'
      preLoaderRoute: typeof TTeamspaceIdFolderIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/showcase/graphql/user-table': {
      id: '/showcase/graphql/user-table'
      path: '/showcase/graphql/user-table'
      fullPath: '/showcase/graphql/user-table'
      preLoaderRoute: typeof ShowcaseGraphqlUserTableLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/paths-playground/': {
      id: '/admin/paths-playground/'
      path: '/admin/paths-playground'
      fullPath: '/admin/paths-playground'
      preLoaderRoute: typeof AdminPathsPlaygroundIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/course/$courseId/': {
      id: '/course/$courseId/'
      path: '/course/$courseId'
      fullPath: '/course/$courseId'
      preLoaderRoute: typeof CourseCourseIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/event/$eventGroupId/': {
      id: '/event/$eventGroupId/'
      path: '/event/$eventGroupId'
      fullPath: '/event/$eventGroupId'
      preLoaderRoute: typeof EventEventGroupIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/l/$liveSessionId/': {
      id: '/l/$liveSessionId/'
      path: '/l/$liveSessionId'
      fullPath: '/l/$liveSessionId'
      preLoaderRoute: typeof LLiveSessionIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/certificates/': {
      id: '/manage/certificates/'
      path: '/manage/certificates'
      fullPath: '/manage/certificates'
      preLoaderRoute: typeof ManageCertificatesIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/exercises/': {
      id: '/manage/exercises/'
      path: '/manage/exercises'
      fullPath: '/manage/exercises'
      preLoaderRoute: typeof ManageExercisesIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/in-person-events/': {
      id: '/manage/in-person-events/'
      path: '/manage/in-person-events'
      fullPath: '/manage/in-person-events'
      preLoaderRoute: typeof ManageInPersonEventsIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/insights/': {
      id: '/manage/insights/'
      path: '/manage/insights'
      fullPath: '/manage/insights'
      preLoaderRoute: typeof ManageInsightsIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/programs/': {
      id: '/manage/programs/'
      path: '/manage/programs'
      fullPath: '/manage/programs'
      preLoaderRoute: typeof ManageProgramsIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/skills/': {
      id: '/manage/skills/'
      path: '/manage/skills'
      fullPath: '/manage/skills'
      preLoaderRoute: typeof ManageSkillsIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/tags/': {
      id: '/manage/tags/'
      path: '/manage/tags'
      fullPath: '/manage/tags'
      preLoaderRoute: typeof ManageTagsIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/user-groups/': {
      id: '/manage/user-groups/'
      path: '/manage/user-groups'
      fullPath: '/manage/user-groups'
      preLoaderRoute: typeof ManageUserGroupsIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/users/': {
      id: '/manage/users/'
      path: '/manage/users'
      fullPath: '/manage/users'
      preLoaderRoute: typeof ManageUsersIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/path/$pathId/': {
      id: '/path/$pathId/'
      path: '/path/$pathId'
      fullPath: '/path/$pathId'
      preLoaderRoute: typeof PathPathIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/': {
      id: '/program/$programId/'
      path: '/program/$programId'
      fullPath: '/program/$programId'
      preLoaderRoute: typeof ProgramProgramIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/room/$liveRoomId/': {
      id: '/room/$liveRoomId/'
      path: '/room/$liveRoomId'
      fullPath: '/room/$liveRoomId'
      preLoaderRoute: typeof RoomLiveRoomIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/s/$flexibleContentId/': {
      id: '/s/$flexibleContentId/'
      path: '/s/$flexibleContentId'
      fullPath: '/s/$flexibleContentId'
      preLoaderRoute: typeof SFlexibleContentIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/settings/api/': {
      id: '/settings/api/'
      path: '/settings/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof SettingsApiIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/t/$teamspaceId/': {
      id: '/t/$teamspaceId/'
      path: '/t/$teamspaceId'
      fullPath: '/t/$teamspaceId'
      preLoaderRoute: typeof TTeamspaceIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/check-in/$eventGroupId/$eventId/qr': {
      id: '/check-in/$eventGroupId/$eventId/qr'
      path: '/check-in/$eventGroupId/$eventId/qr'
      fullPath: '/check-in/$eventGroupId/$eventId/qr'
      preLoaderRoute: typeof CheckInEventGroupIdEventIdQrRouteImport
      parentRoute: typeof rootRoute
    }
    '/create/export/l/$liveContentId': {
      id: '/create/export/l/$liveContentId'
      path: '/create/export/l/$liveContentId'
      fullPath: '/create/export/l/$liveContentId'
      preLoaderRoute: typeof CreateExportLLiveContentIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/create/export/s/$selfPacedContentId': {
      id: '/create/export/s/$selfPacedContentId'
      path: '/create/export/s/$selfPacedContentId'
      fullPath: '/create/export/s/$selfPacedContentId'
      preLoaderRoute: typeof CreateExportSSelfPacedContentIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/in-person-events/$eventGroupId/$calendarEventId': {
      id: '/manage/in-person-events/$eventGroupId/$calendarEventId'
      path: '/manage/in-person-events/$eventGroupId/$calendarEventId'
      fullPath: '/manage/in-person-events/$eventGroupId/$calendarEventId'
      preLoaderRoute: typeof ManageInPersonEventsEventGroupIdCalendarEventIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/user/$userId/export-transcript': {
      id: '/manage/user/$userId/export-transcript'
      path: '/manage/user/$userId/export-transcript'
      fullPath: '/manage/user/$userId/export-transcript'
      preLoaderRoute: typeof ManageUserUserIdExportTranscriptRouteImport
      parentRoute: typeof rootRoute
    }
    '/check-in/$eventGroupId/$eventId/': {
      id: '/check-in/$eventGroupId/$eventId/'
      path: '/check-in/$eventGroupId/$eventId'
      fullPath: '/check-in/$eventGroupId/$eventId'
      preLoaderRoute: typeof CheckInEventGroupIdEventIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/in-person-events/$eventGroupId/': {
      id: '/manage/in-person-events/$eventGroupId/'
      path: '/manage/in-person-events/$eventGroupId'
      fullPath: '/manage/in-person-events/$eventGroupId'
      preLoaderRoute: typeof ManageInPersonEventsEventGroupIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/insights/dashboards/': {
      id: '/manage/insights/dashboards/'
      path: '/manage/insights/dashboards'
      fullPath: '/manage/insights/dashboards'
      preLoaderRoute: typeof ManageInsightsDashboardsIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/path/$pathId/course/$courseId/$': {
      id: '/path/$pathId/course/$courseId/$'
      path: '/path/$pathId/course/$courseId/$'
      fullPath: '/path/$pathId/course/$courseId/$'
      preLoaderRoute: typeof PathPathIdCourseCourseIdSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/path/$pathId/course/$courseId/next': {
      id: '/path/$pathId/course/$courseId/next'
      path: '/path/$pathId/course/$courseId/next'
      fullPath: '/path/$pathId/course/$courseId/next'
      preLoaderRoute: typeof PathPathIdCourseCourseIdNextRouteImport
      parentRoute: typeof rootRoute
    }
    '/path/$pathId/course/$courseId/scorm': {
      id: '/path/$pathId/course/$courseId/scorm'
      path: '/path/$pathId/course/$courseId/scorm'
      fullPath: '/path/$pathId/course/$courseId/scorm'
      preLoaderRoute: typeof PathPathIdCourseCourseIdScormRouteImport
      parentRoute: typeof rootRoute
    }
    '/path/$pathId/s/$flexibleContentId/$fileId': {
      id: '/path/$pathId/s/$flexibleContentId/$fileId'
      path: '/path/$pathId/s/$flexibleContentId/$fileId'
      fullPath: '/path/$pathId/s/$flexibleContentId/$fileId'
      preLoaderRoute: typeof PathPathIdSFlexibleContentIdFileIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/course/$courseId/$': {
      id: '/program/$programId/course/$courseId/$'
      path: '/program/$programId/course/$courseId/$'
      fullPath: '/program/$programId/course/$courseId/$'
      preLoaderRoute: typeof ProgramProgramIdCourseCourseIdSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/course/$courseId/next': {
      id: '/program/$programId/course/$courseId/next'
      path: '/program/$programId/course/$courseId/next'
      fullPath: '/program/$programId/course/$courseId/next'
      preLoaderRoute: typeof ProgramProgramIdCourseCourseIdNextRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/course/$courseId/scorm': {
      id: '/program/$programId/course/$courseId/scorm'
      path: '/program/$programId/course/$courseId/scorm'
      fullPath: '/program/$programId/course/$courseId/scorm'
      preLoaderRoute: typeof ProgramProgramIdCourseCourseIdScormRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/s/$flexibleContentId/$fileId': {
      id: '/program/$programId/s/$flexibleContentId/$fileId'
      path: '/program/$programId/s/$flexibleContentId/$fileId'
      fullPath: '/program/$programId/s/$flexibleContentId/$fileId'
      preLoaderRoute: typeof ProgramProgramIdSFlexibleContentIdFileIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/insights/dashboards/$dashboardId/': {
      id: '/manage/insights/dashboards/$dashboardId/'
      path: '/manage/insights/dashboards/$dashboardId'
      fullPath: '/manage/insights/dashboards/$dashboardId'
      preLoaderRoute: typeof ManageInsightsDashboardsDashboardIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/path/$pathId/course/$courseId/': {
      id: '/path/$pathId/course/$courseId/'
      path: '/path/$pathId/course/$courseId'
      fullPath: '/path/$pathId/course/$courseId'
      preLoaderRoute: typeof PathPathIdCourseCourseIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/path/$pathId/event/$eventGroupId/': {
      id: '/path/$pathId/event/$eventGroupId/'
      path: '/path/$pathId/event/$eventGroupId'
      fullPath: '/path/$pathId/event/$eventGroupId'
      preLoaderRoute: typeof PathPathIdEventEventGroupIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/path/$pathId/s/$flexibleContentId/': {
      id: '/path/$pathId/s/$flexibleContentId/'
      path: '/path/$pathId/s/$flexibleContentId'
      fullPath: '/path/$pathId/s/$flexibleContentId'
      preLoaderRoute: typeof PathPathIdSFlexibleContentIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/course/$courseId/': {
      id: '/program/$programId/course/$courseId/'
      path: '/program/$programId/course/$courseId'
      fullPath: '/program/$programId/course/$courseId'
      preLoaderRoute: typeof ProgramProgramIdCourseCourseIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/event/$eventGroupId/': {
      id: '/program/$programId/event/$eventGroupId/'
      path: '/program/$programId/event/$eventGroupId'
      fullPath: '/program/$programId/event/$eventGroupId'
      preLoaderRoute: typeof ProgramProgramIdEventEventGroupIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/path/$pathId/': {
      id: '/program/$programId/path/$pathId/'
      path: '/program/$programId/path/$pathId'
      fullPath: '/program/$programId/path/$pathId'
      preLoaderRoute: typeof ProgramProgramIdPathPathIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/s/$flexibleContentId/': {
      id: '/program/$programId/s/$flexibleContentId/'
      path: '/program/$programId/s/$flexibleContentId'
      fullPath: '/program/$programId/s/$flexibleContentId'
      preLoaderRoute: typeof ProgramProgramIdSFlexibleContentIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/manage/insights/dashboards/templates/$templateId/': {
      id: '/manage/insights/dashboards/templates/$templateId/'
      path: '/manage/insights/dashboards/templates/$templateId'
      fullPath: '/manage/insights/dashboards/templates/$templateId'
      preLoaderRoute: typeof ManageInsightsDashboardsTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/path/$pathId/course/$courseId/$': {
      id: '/program/$programId/path/$pathId/course/$courseId/$'
      path: '/program/$programId/path/$pathId/course/$courseId/$'
      fullPath: '/program/$programId/path/$pathId/course/$courseId/$'
      preLoaderRoute: typeof ProgramProgramIdPathPathIdCourseCourseIdSplatRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/path/$pathId/course/$courseId/next': {
      id: '/program/$programId/path/$pathId/course/$courseId/next'
      path: '/program/$programId/path/$pathId/course/$courseId/next'
      fullPath: '/program/$programId/path/$pathId/course/$courseId/next'
      preLoaderRoute: typeof ProgramProgramIdPathPathIdCourseCourseIdNextRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/path/$pathId/course/$courseId/scorm': {
      id: '/program/$programId/path/$pathId/course/$courseId/scorm'
      path: '/program/$programId/path/$pathId/course/$courseId/scorm'
      fullPath: '/program/$programId/path/$pathId/course/$courseId/scorm'
      preLoaderRoute: typeof ProgramProgramIdPathPathIdCourseCourseIdScormRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/path/$pathId/s/$flexibleContentId/$fileId': {
      id: '/program/$programId/path/$pathId/s/$flexibleContentId/$fileId'
      path: '/program/$programId/path/$pathId/s/$flexibleContentId/$fileId'
      fullPath: '/program/$programId/path/$pathId/s/$flexibleContentId/$fileId'
      preLoaderRoute: typeof ProgramProgramIdPathPathIdSFlexibleContentIdFileIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/path/$pathId/course/$courseId/': {
      id: '/program/$programId/path/$pathId/course/$courseId/'
      path: '/program/$programId/path/$pathId/course/$courseId'
      fullPath: '/program/$programId/path/$pathId/course/$courseId'
      preLoaderRoute: typeof ProgramProgramIdPathPathIdCourseCourseIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/path/$pathId/event/$eventGroupId/': {
      id: '/program/$programId/path/$pathId/event/$eventGroupId/'
      path: '/program/$programId/path/$pathId/event/$eventGroupId'
      fullPath: '/program/$programId/path/$pathId/event/$eventGroupId'
      preLoaderRoute: typeof ProgramProgramIdPathPathIdEventEventGroupIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId/path/$pathId/s/$flexibleContentId/': {
      id: '/program/$programId/path/$pathId/s/$flexibleContentId/'
      path: '/program/$programId/path/$pathId/s/$flexibleContentId'
      fullPath: '/program/$programId/path/$pathId/s/$flexibleContentId'
      preLoaderRoute: typeof ProgramProgramIdPathPathIdSFlexibleContentIdIndexRouteImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRouteRoute,
  R404RouteRoute,
  AcceptInviteRouteRoute,
  AccessDeniedRouteRoute,
  AccountActionRouteRoute,
  AuthenticateRouteRoute,
  BrowseRouteRoute,
  CertificateV2RouteRoute,
  ContentNotFoundRouteRoute,
  DebugaccessRouteRoute,
  SelectEditionRouteRoute,
  AdminErrorRouteRoute,
  DebugCollaborationRouteRoute,
  DebugErrorAsyncRouteRoute,
  DebugErrorSyncRouteRoute,
  GroupInviteTokenRouteRoute,
  ManageContentRouteRoute,
  ManageOverviewRouteRoute,
  ManageReportsRouteRoute,
  RSplatRouteRoute,
  RecoveryCoursesRouteRoute,
  RecoveryLivesessionsRouteRoute,
  RecoveryUsersRouteRoute,
  ScormDispatchSplatRouteRoute,
  SettingsBrandingRouteRoute,
  SettingsGeneralRouteRoute,
  SettingsNotificationsRouteRoute,
  SkillSkillIdRouteRoute,
  ShowcaseActivityLazyRoute,
  ShowcaseContentPreviewLazyRoute,
  ShowcaseContentSkillsSettingsLazyRoute,
  ShowcaseDatesLazyRoute,
  ShowcaseExperimentalEditorLazyRoute,
  ShowcaseFiltersLazyRoute,
  ShowcaseGenerateIdsLazyRoute,
  ShowcaseImagesLazyRoute,
  ShowcaseInsightsSqlLazyRoute,
  ShowcaseLayoutKitLazyRoute,
  ShowcaseLilStackLazyRoute,
  ShowcaseLoadingSpinnerLazyRoute,
  ShowcaseNotificationsLazyRoute,
  ShowcaseSkillRecommendationLazyRoute,
  ShowcaseSkillsAchievementsModalLazyRoute,
  ShowcaseSkillsBadgesLazyRoute,
  ShowcaseSkillsBoardsLazyRoute,
  ShowcaseSkillsSelectModalLazyRoute,
  ShowcaseTablesLazyRoute,
  ShowcaseTabularLazyRoute,
  CreateNewIndexRouteRoute,
  CreateIndexRouteRoute,
  LearnIndexRouteRoute,
  ShowcaseIndexLazyRoute,
  CourseCourseIdSplatRouteRoute,
  CourseCourseIdNextRouteRoute,
  CourseCourseIdScormRouteRoute,
  CreateLSplatRouteRoute,
  CreateLNewRouteRoute,
  CreateSSplatRouteRoute,
  CreateSNewRouteRoute,
  HistoryLSplatRouteRoute,
  HistorySSplatRouteRoute,
  ManageCertificatesCertificateIdRouteRoute,
  ManageCourseGroupCourseGroupIdRouteRoute,
  ManageCoursesCourseIdRouteRoute,
  ManageEventsLiveSessionIdRouteRoute,
  ManageExercisesExerciseIdRouteRoute,
  ManagePathsPathIdRouteRoute,
  ManageProgramsProgramIdRouteRoute,
  ManageTagsTagIdRouteRoute,
  ManageUserGroupsGroupIdRouteRoute,
  ManageUsersUserIdRouteRoute,
  ManageXApiXApiServerIdRouteRoute,
  SFlexibleContentIdFileIdRouteRoute,
  SettingsApiApiClientIdRouteRoute,
  TTeamspaceIdFolderIdRouteRoute,
  ShowcaseGraphqlUserTableLazyRoute,
  AdminPathsPlaygroundIndexRouteRoute,
  CourseCourseIdIndexRouteRoute,
  EventEventGroupIdIndexRouteRoute,
  LLiveSessionIdIndexRouteRoute,
  ManageCertificatesIndexRouteRoute,
  ManageExercisesIndexRouteRoute,
  ManageInPersonEventsIndexRouteRoute,
  ManageInsightsIndexRouteRoute,
  ManageProgramsIndexRouteRoute,
  ManageSkillsIndexRouteRoute,
  ManageTagsIndexRouteRoute,
  ManageUserGroupsIndexRouteRoute,
  ManageUsersIndexRouteRoute,
  PathPathIdIndexRouteRoute,
  ProgramProgramIdIndexRouteRoute,
  RoomLiveRoomIdIndexRouteRoute,
  SFlexibleContentIdIndexRouteRoute,
  SettingsApiIndexRouteRoute,
  TTeamspaceIdIndexRouteRoute,
  CheckInEventGroupIdEventIdQrRouteRoute,
  CreateExportLLiveContentIdRouteRoute,
  CreateExportSSelfPacedContentIdRouteRoute,
  ManageInPersonEventsEventGroupIdCalendarEventIdRouteRoute,
  ManageUserUserIdExportTranscriptRouteRoute,
  CheckInEventGroupIdEventIdIndexRouteRoute,
  ManageInPersonEventsEventGroupIdIndexRouteRoute,
  ManageInsightsDashboardsIndexRouteRoute,
  PathPathIdCourseCourseIdSplatRouteRoute,
  PathPathIdCourseCourseIdNextRouteRoute,
  PathPathIdCourseCourseIdScormRouteRoute,
  PathPathIdSFlexibleContentIdFileIdRouteRoute,
  ProgramProgramIdCourseCourseIdSplatRouteRoute,
  ProgramProgramIdCourseCourseIdNextRouteRoute,
  ProgramProgramIdCourseCourseIdScormRouteRoute,
  ProgramProgramIdSFlexibleContentIdFileIdRouteRoute,
  ManageInsightsDashboardsDashboardIdIndexRouteRoute,
  PathPathIdCourseCourseIdIndexRouteRoute,
  PathPathIdEventEventGroupIdIndexRouteRoute,
  PathPathIdSFlexibleContentIdIndexRouteRoute,
  ProgramProgramIdCourseCourseIdIndexRouteRoute,
  ProgramProgramIdEventEventGroupIdIndexRouteRoute,
  ProgramProgramIdPathPathIdIndexRouteRoute,
  ProgramProgramIdSFlexibleContentIdIndexRouteRoute,
  ManageInsightsDashboardsTemplatesTemplateIdIndexRouteRoute,
  ProgramProgramIdPathPathIdCourseCourseIdSplatRouteRoute,
  ProgramProgramIdPathPathIdCourseCourseIdNextRouteRoute,
  ProgramProgramIdPathPathIdCourseCourseIdScormRouteRoute,
  ProgramProgramIdPathPathIdSFlexibleContentIdFileIdRouteRoute,
  ProgramProgramIdPathPathIdCourseCourseIdIndexRouteRoute,
  ProgramProgramIdPathPathIdEventEventGroupIdIndexRouteRoute,
  ProgramProgramIdPathPathIdSFlexibleContentIdIndexRouteRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/404",
        "/accept-invite",
        "/access-denied",
        "/account-action",
        "/authenticate",
        "/browse",
        "/certificate-v2",
        "/content-not-found",
        "/debugaccess",
        "/select-edition",
        "/admin/error",
        "/debug/collaboration",
        "/debug/error-async",
        "/debug/error-sync",
        "/group-invite/$token",
        "/manage/content",
        "/manage/overview",
        "/manage/reports",
        "/r/$",
        "/recovery/courses",
        "/recovery/livesessions",
        "/recovery/users",
        "/scorm-dispatch/$",
        "/settings/branding",
        "/settings/general",
        "/settings/notifications",
        "/skill/$skillId",
        "/showcase/activity",
        "/showcase/content-preview",
        "/showcase/content-skills-settings",
        "/showcase/dates",
        "/showcase/experimental-editor",
        "/showcase/filters",
        "/showcase/generate-ids",
        "/showcase/images",
        "/showcase/insights-sql",
        "/showcase/layout-kit",
        "/showcase/lil-stack",
        "/showcase/loading-spinner",
        "/showcase/notifications",
        "/showcase/skill-recommendation",
        "/showcase/skills-achievements-modal",
        "/showcase/skills-badges",
        "/showcase/skills-boards",
        "/showcase/skills-select-modal",
        "/showcase/tables",
        "/showcase/tabular",
        "/create-new/",
        "/create/",
        "/learn/",
        "/showcase/",
        "/course/$courseId/$",
        "/course/$courseId/next",
        "/course/$courseId/scorm",
        "/create/l/$",
        "/create/l/new",
        "/create/s/$",
        "/create/s/new",
        "/history/l/$",
        "/history/s/$",
        "/manage/certificates/$certificateId",
        "/manage/course-group/$courseGroupId",
        "/manage/courses/$courseId",
        "/manage/events/$liveSessionId",
        "/manage/exercises/$exerciseId",
        "/manage/paths/$pathId",
        "/manage/programs/$programId",
        "/manage/tags/$tagId",
        "/manage/user-groups/$groupId",
        "/manage/users/$userId",
        "/manage/x-api/$xApiServerId",
        "/s/$flexibleContentId/$fileId",
        "/settings/api/$apiClientId",
        "/t/$teamspaceId/$folderId",
        "/showcase/graphql/user-table",
        "/admin/paths-playground/",
        "/course/$courseId/",
        "/event/$eventGroupId/",
        "/l/$liveSessionId/",
        "/manage/certificates/",
        "/manage/exercises/",
        "/manage/in-person-events/",
        "/manage/insights/",
        "/manage/programs/",
        "/manage/skills/",
        "/manage/tags/",
        "/manage/user-groups/",
        "/manage/users/",
        "/path/$pathId/",
        "/program/$programId/",
        "/room/$liveRoomId/",
        "/s/$flexibleContentId/",
        "/settings/api/",
        "/t/$teamspaceId/",
        "/check-in/$eventGroupId/$eventId/qr",
        "/create/export/l/$liveContentId",
        "/create/export/s/$selfPacedContentId",
        "/manage/in-person-events/$eventGroupId/$calendarEventId",
        "/manage/user/$userId/export-transcript",
        "/check-in/$eventGroupId/$eventId/",
        "/manage/in-person-events/$eventGroupId/",
        "/manage/insights/dashboards/",
        "/path/$pathId/course/$courseId/$",
        "/path/$pathId/course/$courseId/next",
        "/path/$pathId/course/$courseId/scorm",
        "/path/$pathId/s/$flexibleContentId/$fileId",
        "/program/$programId/course/$courseId/$",
        "/program/$programId/course/$courseId/next",
        "/program/$programId/course/$courseId/scorm",
        "/program/$programId/s/$flexibleContentId/$fileId",
        "/manage/insights/dashboards/$dashboardId/",
        "/path/$pathId/course/$courseId/",
        "/path/$pathId/event/$eventGroupId/",
        "/path/$pathId/s/$flexibleContentId/",
        "/program/$programId/course/$courseId/",
        "/program/$programId/event/$eventGroupId/",
        "/program/$programId/path/$pathId/",
        "/program/$programId/s/$flexibleContentId/",
        "/manage/insights/dashboards/templates/$templateId/",
        "/program/$programId/path/$pathId/course/$courseId/$",
        "/program/$programId/path/$pathId/course/$courseId/next",
        "/program/$programId/path/$pathId/course/$courseId/scorm",
        "/program/$programId/path/$pathId/s/$flexibleContentId/$fileId",
        "/program/$programId/path/$pathId/course/$courseId/",
        "/program/$programId/path/$pathId/event/$eventGroupId/",
        "/program/$programId/path/$pathId/s/$flexibleContentId/"
      ]
    },
    "/": {
      "filePath": "index.route.tsx"
    },
    "/404": {
      "filePath": "404.route.tsx"
    },
    "/accept-invite": {
      "filePath": "accept-invite.route.tsx"
    },
    "/access-denied": {
      "filePath": "access-denied.route.tsx"
    },
    "/account-action": {
      "filePath": "account-action.route.tsx"
    },
    "/authenticate": {
      "filePath": "authenticate.route.tsx"
    },
    "/browse": {
      "filePath": "browse.route.tsx"
    },
    "/certificate-v2": {
      "filePath": "certificate-v2.route.tsx"
    },
    "/content-not-found": {
      "filePath": "content-not-found.route.tsx"
    },
    "/debugaccess": {
      "filePath": "debugaccess.route.tsx"
    },
    "/select-edition": {
      "filePath": "select-edition.route.tsx"
    },
    "/admin/error": {
      "filePath": "admin/error.route.tsx"
    },
    "/debug/collaboration": {
      "filePath": "debug/collaboration.route.tsx"
    },
    "/debug/error-async": {
      "filePath": "debug/error-async.route.tsx"
    },
    "/debug/error-sync": {
      "filePath": "debug/error-sync.route.tsx"
    },
    "/group-invite/$token": {
      "filePath": "group-invite/$token.route.tsx"
    },
    "/manage/content": {
      "filePath": "manage/content.route.tsx"
    },
    "/manage/overview": {
      "filePath": "manage/overview.route.tsx"
    },
    "/manage/reports": {
      "filePath": "manage/reports.route.tsx"
    },
    "/r/$": {
      "filePath": "r/$.route.tsx"
    },
    "/recovery/courses": {
      "filePath": "recovery/courses.route.tsx"
    },
    "/recovery/livesessions": {
      "filePath": "recovery/livesessions.route.tsx"
    },
    "/recovery/users": {
      "filePath": "recovery/users.route.tsx"
    },
    "/scorm-dispatch/$": {
      "filePath": "scorm-dispatch/$.route.tsx"
    },
    "/settings/branding": {
      "filePath": "settings/branding.route.tsx"
    },
    "/settings/general": {
      "filePath": "settings/general.route.tsx"
    },
    "/settings/notifications": {
      "filePath": "settings/notifications.route.tsx"
    },
    "/skill/$skillId": {
      "filePath": "skill/$skillId.route.tsx"
    },
    "/showcase/activity": {
      "filePath": "showcase/activity.lazy.tsx"
    },
    "/showcase/content-preview": {
      "filePath": "showcase/content-preview.lazy.tsx"
    },
    "/showcase/content-skills-settings": {
      "filePath": "showcase/content-skills-settings.lazy.tsx"
    },
    "/showcase/dates": {
      "filePath": "showcase/dates.lazy.tsx"
    },
    "/showcase/experimental-editor": {
      "filePath": "showcase/experimental-editor.lazy.tsx"
    },
    "/showcase/filters": {
      "filePath": "showcase/filters.lazy.tsx"
    },
    "/showcase/generate-ids": {
      "filePath": "showcase/generate-ids.lazy.tsx"
    },
    "/showcase/images": {
      "filePath": "showcase/images.lazy.tsx"
    },
    "/showcase/insights-sql": {
      "filePath": "showcase/insights-sql.lazy.tsx"
    },
    "/showcase/layout-kit": {
      "filePath": "showcase/layout-kit.lazy.tsx"
    },
    "/showcase/lil-stack": {
      "filePath": "showcase/lil-stack.lazy.tsx"
    },
    "/showcase/loading-spinner": {
      "filePath": "showcase/loading-spinner.lazy.tsx"
    },
    "/showcase/notifications": {
      "filePath": "showcase/notifications.lazy.tsx"
    },
    "/showcase/skill-recommendation": {
      "filePath": "showcase/skill-recommendation.lazy.tsx"
    },
    "/showcase/skills-achievements-modal": {
      "filePath": "showcase/skills-achievements-modal.lazy.tsx"
    },
    "/showcase/skills-badges": {
      "filePath": "showcase/skills-badges.lazy.tsx"
    },
    "/showcase/skills-boards": {
      "filePath": "showcase/skills-boards.lazy.tsx"
    },
    "/showcase/skills-select-modal": {
      "filePath": "showcase/skills-select-modal.lazy.tsx"
    },
    "/showcase/tables": {
      "filePath": "showcase/tables.lazy.tsx"
    },
    "/showcase/tabular": {
      "filePath": "showcase/tabular.lazy.tsx"
    },
    "/create-new/": {
      "filePath": "create-new/index.route.tsx"
    },
    "/create/": {
      "filePath": "create/index.route.tsx"
    },
    "/learn/": {
      "filePath": "learn/index.route.tsx"
    },
    "/showcase/": {
      "filePath": "showcase/index.lazy.tsx"
    },
    "/course/$courseId/$": {
      "filePath": "course/$courseId/$.route.tsx"
    },
    "/course/$courseId/next": {
      "filePath": "course/$courseId/next.route.tsx"
    },
    "/course/$courseId/scorm": {
      "filePath": "course/$courseId/scorm.route.tsx"
    },
    "/create/l/$": {
      "filePath": "create/l/$.route.tsx"
    },
    "/create/l/new": {
      "filePath": "create/l/new.route.tsx"
    },
    "/create/s/$": {
      "filePath": "create/s/$.route.tsx"
    },
    "/create/s/new": {
      "filePath": "create/s/new.route.tsx"
    },
    "/history/l/$": {
      "filePath": "history/l/$.route.tsx"
    },
    "/history/s/$": {
      "filePath": "history/s/$.route.tsx"
    },
    "/manage/certificates/$certificateId": {
      "filePath": "manage/certificates/$certificateId.route.tsx"
    },
    "/manage/course-group/$courseGroupId": {
      "filePath": "manage/course-group/$courseGroupId.route.tsx"
    },
    "/manage/courses/$courseId": {
      "filePath": "manage/courses/$courseId.route.tsx"
    },
    "/manage/events/$liveSessionId": {
      "filePath": "manage/events/$liveSessionId.route.tsx"
    },
    "/manage/exercises/$exerciseId": {
      "filePath": "manage/exercises/$exerciseId.route.tsx"
    },
    "/manage/paths/$pathId": {
      "filePath": "manage/paths/$pathId.route.tsx"
    },
    "/manage/programs/$programId": {
      "filePath": "manage/programs/$programId.route.tsx"
    },
    "/manage/tags/$tagId": {
      "filePath": "manage/tags/$tagId.route.tsx"
    },
    "/manage/user-groups/$groupId": {
      "filePath": "manage/user-groups/$groupId.route.tsx"
    },
    "/manage/users/$userId": {
      "filePath": "manage/users/$userId.route.tsx"
    },
    "/manage/x-api/$xApiServerId": {
      "filePath": "manage/x-api/$xApiServerId.route.tsx"
    },
    "/s/$flexibleContentId/$fileId": {
      "filePath": "s/$flexibleContentId/$fileId.route.tsx"
    },
    "/settings/api/$apiClientId": {
      "filePath": "settings/api/$apiClientId.route.tsx"
    },
    "/t/$teamspaceId/$folderId": {
      "filePath": "t/$teamspaceId/$folderId.route.tsx"
    },
    "/showcase/graphql/user-table": {
      "filePath": "showcase/graphql/user-table.lazy.tsx"
    },
    "/admin/paths-playground/": {
      "filePath": "admin/paths-playground/index.route.tsx"
    },
    "/course/$courseId/": {
      "filePath": "course/$courseId/index.route.tsx"
    },
    "/event/$eventGroupId/": {
      "filePath": "event/$eventGroupId/index.route.tsx"
    },
    "/l/$liveSessionId/": {
      "filePath": "l/$liveSessionId/index.route.tsx"
    },
    "/manage/certificates/": {
      "filePath": "manage/certificates/index.route.tsx"
    },
    "/manage/exercises/": {
      "filePath": "manage/exercises/index.route.tsx"
    },
    "/manage/in-person-events/": {
      "filePath": "manage/in-person-events/index.route.tsx"
    },
    "/manage/insights/": {
      "filePath": "manage/insights/index.route.tsx"
    },
    "/manage/programs/": {
      "filePath": "manage/programs/index.route.tsx"
    },
    "/manage/skills/": {
      "filePath": "manage/skills/index.route.tsx"
    },
    "/manage/tags/": {
      "filePath": "manage/tags/index.route.tsx"
    },
    "/manage/user-groups/": {
      "filePath": "manage/user-groups/index.route.tsx"
    },
    "/manage/users/": {
      "filePath": "manage/users/index.route.tsx"
    },
    "/path/$pathId/": {
      "filePath": "path/$pathId/index.route.tsx"
    },
    "/program/$programId/": {
      "filePath": "program/$programId/index.route.tsx"
    },
    "/room/$liveRoomId/": {
      "filePath": "room/$liveRoomId/index.route.tsx"
    },
    "/s/$flexibleContentId/": {
      "filePath": "s/$flexibleContentId/index.route.tsx"
    },
    "/settings/api/": {
      "filePath": "settings/api/index.route.tsx"
    },
    "/t/$teamspaceId/": {
      "filePath": "t/$teamspaceId/index.route.tsx"
    },
    "/check-in/$eventGroupId/$eventId/qr": {
      "filePath": "check-in/$eventGroupId/$eventId/qr.route.tsx"
    },
    "/create/export/l/$liveContentId": {
      "filePath": "create/export/l/$liveContentId.route.tsx"
    },
    "/create/export/s/$selfPacedContentId": {
      "filePath": "create/export/s/$selfPacedContentId.route.tsx"
    },
    "/manage/in-person-events/$eventGroupId/$calendarEventId": {
      "filePath": "manage/in-person-events/$eventGroupId/$calendarEventId.route.tsx"
    },
    "/manage/user/$userId/export-transcript": {
      "filePath": "manage/user/$userId/export-transcript.route.tsx"
    },
    "/check-in/$eventGroupId/$eventId/": {
      "filePath": "check-in/$eventGroupId/$eventId/index.route.tsx"
    },
    "/manage/in-person-events/$eventGroupId/": {
      "filePath": "manage/in-person-events/$eventGroupId/index.route.tsx"
    },
    "/manage/insights/dashboards/": {
      "filePath": "manage/insights/dashboards/index.route.tsx"
    },
    "/path/$pathId/course/$courseId/$": {
      "filePath": "path/$pathId/course/$courseId/$.route.tsx"
    },
    "/path/$pathId/course/$courseId/next": {
      "filePath": "path/$pathId/course/$courseId/next.route.tsx"
    },
    "/path/$pathId/course/$courseId/scorm": {
      "filePath": "path/$pathId/course/$courseId/scorm.route.tsx"
    },
    "/path/$pathId/s/$flexibleContentId/$fileId": {
      "filePath": "path/$pathId/s/$flexibleContentId/$fileId.route.tsx"
    },
    "/program/$programId/course/$courseId/$": {
      "filePath": "program/$programId/course/$courseId/$.route.tsx"
    },
    "/program/$programId/course/$courseId/next": {
      "filePath": "program/$programId/course/$courseId/next.route.tsx"
    },
    "/program/$programId/course/$courseId/scorm": {
      "filePath": "program/$programId/course/$courseId/scorm.route.tsx"
    },
    "/program/$programId/s/$flexibleContentId/$fileId": {
      "filePath": "program/$programId/s/$flexibleContentId/$fileId.route.tsx"
    },
    "/manage/insights/dashboards/$dashboardId/": {
      "filePath": "manage/insights/dashboards/$dashboardId/index.route.tsx"
    },
    "/path/$pathId/course/$courseId/": {
      "filePath": "path/$pathId/course/$courseId/index.route.tsx"
    },
    "/path/$pathId/event/$eventGroupId/": {
      "filePath": "path/$pathId/event/$eventGroupId/index.route.tsx"
    },
    "/path/$pathId/s/$flexibleContentId/": {
      "filePath": "path/$pathId/s/$flexibleContentId/index.route.tsx"
    },
    "/program/$programId/course/$courseId/": {
      "filePath": "program/$programId/course/$courseId/index.route.tsx"
    },
    "/program/$programId/event/$eventGroupId/": {
      "filePath": "program/$programId/event/$eventGroupId/index.route.tsx"
    },
    "/program/$programId/path/$pathId/": {
      "filePath": "program/$programId/path/$pathId/index.route.tsx"
    },
    "/program/$programId/s/$flexibleContentId/": {
      "filePath": "program/$programId/s/$flexibleContentId/index.route.tsx"
    },
    "/manage/insights/dashboards/templates/$templateId/": {
      "filePath": "manage/insights/dashboards/templates/$templateId/index.route.tsx"
    },
    "/program/$programId/path/$pathId/course/$courseId/$": {
      "filePath": "program/$programId/path/$pathId/course/$courseId/$.route.tsx"
    },
    "/program/$programId/path/$pathId/course/$courseId/next": {
      "filePath": "program/$programId/path/$pathId/course/$courseId/next.route.tsx"
    },
    "/program/$programId/path/$pathId/course/$courseId/scorm": {
      "filePath": "program/$programId/path/$pathId/course/$courseId/scorm.route.tsx"
    },
    "/program/$programId/path/$pathId/s/$flexibleContentId/$fileId": {
      "filePath": "program/$programId/path/$pathId/s/$flexibleContentId/$fileId.route.tsx"
    },
    "/program/$programId/path/$pathId/course/$courseId/": {
      "filePath": "program/$programId/path/$pathId/course/$courseId/index.route.tsx"
    },
    "/program/$programId/path/$pathId/event/$eventGroupId/": {
      "filePath": "program/$programId/path/$pathId/event/$eventGroupId/index.route.tsx"
    },
    "/program/$programId/path/$pathId/s/$flexibleContentId/": {
      "filePath": "program/$programId/path/$pathId/s/$flexibleContentId/index.route.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
